export default __webpack_public_path__ + "static/media/card5.4a65db42.png";